module.exports = __webpack_public_path__ + "images/LMS.82c033ee.webp";